<!-- 阿里云语音识别 -->
<template>
	<div class="microphone" @click="start">
		<img src="./yuyin.png">
	</div>
</template>

<script>
	let audioStream, websocket, audioContext, scriptProcessor, audioInput

	export default {
		components: {},
		data() {
			return {
				appkey: window.ALYYY.appkey || 'wzd8UEC7iD97gXhb',
				token: window.ALYYY.token || '6f844c813b8c4a8eb817e6f5b4284a56',
				msgList: [],
				io: false,
				count: 0
			}
		},
		computed: {

		},
		watch: {

		},
		created() {
			this.connectWebSocket()
		},
		mounted() {

		},
		beforeDestroy() {
			this.stop()
			this.disconnectWebSocket()
		},
		methods: {
			// 开始
			async start() {
				this.msgList = []
				if (this.io) {
					try {
						audioStream = await navigator.mediaDevices.getUserMedia({
							audio: true
						})

						console.log('麦克风权限已获取')

						audioContext = new(window.AudioContext || window.webkitAudioContext)({
							sampleRate: 16000
						})

						audioInput = audioContext.createMediaStreamSource(audioStream)

						// 设置缓冲区大小
						scriptProcessor = audioContext.createScriptProcessor(1024 * 3 , 1, 1)

						scriptProcessor.onaudioprocess = function(event) {
							const inputData = event.inputBuffer.getChannelData(0)
							const inputData16 = new Int16Array(inputData.length)
							for (let i = 0; i < inputData.length; ++i) {
								inputData16[i] = Math.max(-1, Math.min(1, inputData[i])) * 0x7FFF
							}
							if (websocket && websocket.readyState === WebSocket.OPEN) {
								websocket.send(inputData16.buffer)
							}
						}
						audioInput.connect(scriptProcessor)
						scriptProcessor.connect(audioContext.destination)

						setTimeout(() => {
							this.$emit('start')
						}, 500)
					} catch (e) {
						this.$alert('录音失败: ' + e)
					}
				} else {
					this.$message('语音流链接失败')
				}
			},

			// 发送
			send(callback) {
				if (this.io) {
					callback && callback(JSON.parse(JSON.stringify(this.msgList)))
					this.msgList = []
					this.stop()
				} else {
					this.$message('语音失败发送')
				}
			},

			// 断开WebSocket连接
			disconnectWebSocket() {
				this.msgList = []
				if (websocket) {
					websocket.close()
				}
			},

			// 结束
			stop() {
				this.msgList = []
				this.$emit('end')
				if (scriptProcessor) {
					scriptProcessor.disconnect()
				}
				if (audioInput) {
					audioInput.disconnect()
				}
				if (audioStream) {
					try {
						audioStream.getTracks().forEach(track => track.stop())
					} catch (e) {}
				}
				if (audioContext) {
					audioContext.close()
				}
			},

			// 生成 UUID
			generateUUID() {
				return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
					(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
				).replace(/-/g, '');
			},

			// 打开WebSocket连接
			connectWebSocket() {
				this.count++
				console.log('尝试连接: ' + this.count)
				websocket = new WebSocket(`wss://nls-gateway.cn-shanghai.aliyuncs.com/ws/v1?token=${this.token}`);
				websocket.onopen = () => {
					console.log('已连接')
					this.io = true

					// 连接到 WebSocket 服务器
					let startTranscriptionMessage = {
						header: {
							appkey: this.appkey,
							namespace: "SpeechTranscriber",
							name: "StartTranscription",
							task_id: this.generateUUID(),
							message_id: this.generateUUID()
						},
						payload: {
							"format": "pcm",
							"sample_rate": 16000,
							"enable_intermediate_result": true,
							"enable_punctuation_prediction": true,
							"enable_inverse_text_normalization": true
						}
					}
					websocket.send(JSON.stringify(startTranscriptionMessage))
				}

				websocket.onmessage = (event) => {
					if (event && event.data) {
						let data = JSON.parse(event.data)
						if (!this.msgList.length || !data.payload.result) {
							this.msgList.push('')
						}
						if (data.payload.result) {
							this.msgList[this.msgList.length - 1] = data.payload.result
						}
						console.log('监听-服务端: ', data.payload.result)
					}
				}

				websocket.onerror = (event) => {
					console.log('监听: 错误')
				}

				websocket.onclose = () => {
					console.log('监听: 断开连接')
					this.connectWebSocket()
					this.io = false
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.microphone {
		width: 26px;
		height: 26px;
		display: inline-block;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		#audioElement {
			width: 0;
			height: 0;
			visibility: hidden;
			display: block;
		}
	}
</style>